module.exports = __webpack_public_path__ + "static/teresita-de-la-torre-2-3d89d09c5bc2b7434cce87c8d27ffce3.jpg";